for (const el of document.querySelectorAll('.vp-block-entretiens')) {
  const select = el.querySelector('.select select')
  select.value = ''
  select.addEventListener('input', (e) => {
    el.querySelector(`[data-region].active`)?.classList.remove('active')
    el.querySelector(`[data-region="${select.value}"]`)?.classList.add('active')
  })
}
